var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo5Euro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 154,
    viewBox: "0 0 115 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1278 146.282C29.505 146.282 28.9551 146.534 28.4781 147.037L26.1528 146.64L26.4509 139.087H34.3015V141.552H28.9353L28.816 144.394C29.399 144.076 30.0615 143.917 30.8035 143.917C32.0093 143.917 33.0361 144.328 33.8841 145.149C34.7321 145.971 35.1561 147.011 35.1561 148.27C35.1561 149.727 34.7123 150.926 33.8245 151.867C32.9368 152.795 31.8039 153.258 30.4259 153.258C29.7236 153.258 29.081 153.152 28.498 152.94C27.915 152.728 27.438 152.45 27.067 152.106C26.7093 151.748 26.4178 151.383 26.1925 151.012C25.9673 150.628 25.8016 150.237 25.6956 149.84L28.1204 149.085C28.2529 149.575 28.5046 149.966 28.8756 150.257C29.2466 150.549 29.717 150.694 30.2868 150.694C30.883 150.694 31.3733 150.489 31.7575 150.078C32.1418 149.654 32.3339 149.124 32.3339 148.488C32.3339 147.892 32.1418 147.375 31.7575 146.938C31.3865 146.501 30.8433 146.282 30.1278 146.282ZM34.2297 148.409V146.6H35.2234C35.1969 146.494 35.1837 146.302 35.1837 146.024C35.1837 145.838 35.1969 145.626 35.2234 145.388H34.2297V143.559H35.5812C36.0184 142.168 36.8201 141.035 37.9861 140.161C39.1653 139.273 40.5234 138.829 42.0604 138.829C43.5047 138.829 44.6906 139.127 45.6181 139.723L44.4653 142.009C43.7366 141.598 42.9548 141.393 42.1201 141.393C41.3383 141.393 40.6361 141.592 40.0133 141.989C39.3906 142.373 38.9334 142.897 38.6419 143.559H43.0343L42.8554 145.388H38.1451C38.1186 145.653 38.1053 145.858 38.1053 146.004C38.1053 146.242 38.1252 146.441 38.1649 146.6H42.7561L42.5772 148.409H38.7214C39.0262 149.085 39.4899 149.621 40.1127 150.019C40.7354 150.416 41.4509 150.615 42.2592 150.615C43.2132 150.615 44.0214 150.396 44.6839 149.959L45.7572 152.225C45.4657 152.49 45.0019 152.728 44.3659 152.94C43.7299 153.152 43.0277 153.258 42.2592 153.258C40.5897 153.258 39.1653 152.814 37.9861 151.927C36.8068 151.026 35.9986 149.853 35.5613 148.409H34.2297Z",
    fill: "#77B668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8565 147.018C51.3824 147.533 51.1454 148.187 51.1454 148.981C51.1454 149.774 51.3824 150.429 51.8565 150.944C52.3408 151.449 52.9591 151.701 53.7115 151.701C54.4638 151.701 55.0821 151.444 55.5665 150.929C56.0611 150.413 56.3085 149.759 56.3085 148.965C56.3085 148.172 56.0611 147.517 55.5665 147.002C55.0821 146.487 54.4638 146.229 53.7115 146.229C52.9591 146.229 52.3408 146.492 51.8565 147.018ZM49.445 148.981C49.445 147.765 49.852 146.755 50.6662 145.951C51.4803 145.137 52.4954 144.73 53.7115 144.73C54.9481 144.73 55.9684 145.132 56.7722 145.936C57.5863 146.739 57.9934 147.749 57.9934 148.965C57.9934 150.181 57.5863 151.191 56.7722 151.995C55.9581 152.799 54.9378 153.201 53.7115 153.201C52.4748 153.201 51.4545 152.804 50.6507 152.011C49.8469 151.217 49.445 150.207 49.445 148.981ZM59.6989 153V146.322H58.8178V144.931H59.6989V144.575C59.6989 143.617 59.9565 142.921 60.4718 142.488C60.9871 142.055 61.6467 141.839 62.4505 141.839L63.0534 141.87V143.308C62.9091 143.287 62.7751 143.277 62.6514 143.277C61.8064 143.277 61.3839 143.72 61.3839 144.606V144.931H62.9452V146.322H61.3839V153H59.6989ZM64.4843 153V146.322H63.6032V144.931H64.4843V144.575C64.4843 143.617 64.742 142.921 65.2573 142.488C65.7725 142.055 66.4321 141.839 67.2359 141.839L67.8388 141.87V143.308C67.6945 143.287 67.5605 143.277 67.4369 143.277C66.5918 143.277 66.1693 143.72 66.1693 144.606V144.931H67.7306V146.322H66.1693V153H64.4843ZM69.4898 152.026C68.7169 151.243 68.3304 150.233 68.3304 148.996C68.3304 147.76 68.7066 146.739 69.4589 145.936C70.2112 145.132 71.1439 144.73 72.2569 144.73C73.4626 144.73 74.4107 145.116 75.1012 145.889C75.7917 146.652 76.1369 147.672 76.1369 148.95C76.1369 149.135 76.1318 149.275 76.1214 149.367H70.0463C70.0566 150.078 70.2937 150.65 70.7574 151.083C71.2315 151.516 71.8292 151.732 72.5506 151.732C73.5193 151.732 74.2613 151.356 74.7766 150.604L75.8896 151.439C75.6319 151.882 75.2197 152.289 74.6529 152.66C74.0861 153.021 73.375 153.201 72.5197 153.201C71.2727 153.201 70.2627 152.809 69.4898 152.026ZM70.1082 148.208H74.421C74.3901 147.559 74.1737 147.054 73.7718 146.693C73.3699 146.322 72.87 146.136 72.2723 146.136C71.6849 146.136 71.1902 146.327 70.7883 146.708C70.3864 147.079 70.1597 147.579 70.1082 148.208ZM81.4472 144.73V146.43C79.9323 146.43 79.1748 147.461 79.1748 149.522V153H77.4899V144.931H79.1439V146.198C79.3088 145.776 79.5974 145.425 80.0096 145.147C80.4218 144.869 80.901 144.73 81.4472 144.73ZM83.3051 144.931V143.246H84.9746V144.931H86.6132V146.322H84.9746V150.078C84.9746 150.676 85.0828 151.083 85.2992 151.3C85.5156 151.506 85.866 151.609 86.3504 151.609L86.675 151.593V153.046C86.4792 153.088 86.2061 153.108 85.8557 153.108C84.9282 153.108 84.2687 152.825 83.8771 152.258C83.4958 151.691 83.3051 150.877 83.3051 149.816V146.322H82.4085V144.931H83.3051Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1169 31.1725C33.1169 31.1725 15.144 40.2545 6.18016 54.2493C-2.78372 68.2442 -2.07448 86.2483 8.81785 99.6125C19.7102 112.977 40.5294 111.222 57.9614 119.687C75.3934 128.153 94.6258 126.409 102.869 108.473C111.111 90.5375 98.6819 83.8342 96.5471 63.0773C94.4123 42.3203 75.5476 11.926 33.1169 31.1725Z",
    fill: "#92E3A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M33.1169 31.1725C33.1169 31.1725 15.144 40.2545 6.18016 54.2493C-2.78372 68.2442 -2.07448 86.2483 8.81785 99.6125C19.7102 112.977 40.5294 111.222 57.9614 119.687C75.3934 128.153 94.6258 126.409 102.869 108.473C111.111 90.5375 98.6819 83.8342 96.5471 63.0773C94.4123 42.3203 75.5476 11.926 33.1169 31.1725Z",
    fill: "url(#paint0_linear_5857_23293)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3336 42.3006C82.8945 38.4091 83.3737 27.5325 77.404 18.0069C71.4344 8.48137 61.2763 3.91403 54.7155 7.80547C48.1546 11.6969 47.6753 22.5736 53.645 32.0991C59.6147 41.6247 69.7727 46.192 76.3336 42.3006Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M78.1682 40.8811C72.7072 46.3145 62.6097 43.6386 55.6238 34.9012C48.638 26.1638 47.4013 14.676 52.8696 9.23911C57.7068 4.42325 66.1774 5.97412 72.9006 12.4544C73.7724 13.292 74.6151 14.2147 75.4177 15.219C75.8773 15.7939 76.3114 16.3795 76.7164 16.9757C82.5348 25.4363 83.279 35.8027 78.1719 40.8811H78.1682Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7281 16.9783L72.4016 18.5079L68.2539 14.2563L72.9124 12.457C73.7842 13.2946 74.6269 14.2173 75.4294 15.2216C75.8891 15.7966 76.3232 16.3821 76.7281 16.9783Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1405 6.92188L53.9805 9.77874",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8843 7.92188L57.1328 10.5516",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3007 9.73047L60.1406 12.5909",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4686 29.9883L72.3086 32.8487",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.453 33.4863L72.293 36.3467",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6014 36.9668L71.4414 39.8272",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8479 12.541L63.9141 15.405",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7264 17.0664L67.5664 19.9268",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3336 42.3006C82.8945 38.4091 83.3737 27.5325 77.404 18.0069C71.4344 8.48137 61.2763 3.91403 54.7155 7.80547C48.1546 11.6969 47.6753 22.5736 53.645 32.0991C59.6147 41.6247 69.7727 46.192 76.3336 42.3006Z",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3062 43.449C80.8671 39.5576 81.3464 28.6809 75.3767 19.1554C69.407 9.62981 59.249 5.06246 52.6881 8.95391C46.1272 12.8454 45.648 23.722 51.6177 33.2475C57.5873 42.7731 67.7454 47.3404 74.3062 43.449Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6538 40.838C78.2204 37.5363 78.6257 28.3058 73.559 20.2211C68.4923 12.1364 59.8724 8.25908 54.3058 11.5608C48.7392 14.8625 48.3339 24.093 53.4006 32.1777C58.4673 40.2623 67.0872 44.1397 72.6538 40.838Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M72.6538 40.838C78.2204 37.5363 78.6257 28.3058 73.559 20.2211C68.4923 12.1364 59.8724 8.25908 54.3058 11.5608C48.7392 14.8625 48.3339 24.093 53.4006 32.1777C58.4673 40.2623 67.0872 44.1397 72.6538 40.838Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6538 40.838C78.2204 37.5363 78.6257 28.3058 73.559 20.2211C68.4923 12.1364 59.8724 8.25908 54.3058 11.5608C48.7392 14.8625 48.3339 24.093 53.4006 32.1777C58.4673 40.2623 67.0872 44.1397 72.6538 40.838Z",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9087 33.9445C49.9807 26.5308 48.9338 16.7784 53.5703 12.1684C53.7199 12.0194 53.8731 11.881 54.03 11.7461C53.5776 12.0407 53.1508 12.3813 52.7532 12.7788C48.1166 17.3924 49.1636 27.1412 55.0915 34.5549C60.8298 41.7308 69.0377 44.0908 73.7654 40.0522C68.9538 43.2 61.3295 40.7264 55.9123 33.9445H55.9087Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2247 34.6331L61.2105 33.3484L60.3897 34.4024L59.4084 33.1603L60.2292 32.1062L59.1786 30.7754L58.3578 31.8294L57.3765 30.5873L58.1973 29.5333L57.1102 28.1599C54.17 24.4371 53.3163 20.9307 56.3697 17.0057C59.423 13.0806 61.8562 14.2411 64.2748 17.3002L65.1321 18.3862L62.2611 22.077L61.2105 20.7462C60.3861 19.7028 59.496 18.6169 58.5767 19.7986C57.6574 20.9804 58.4527 22.2367 59.3099 23.3227L61.185 25.6934L62.8922 23.5001L63.8735 24.7423L62.1663 26.9355L63.2169 28.2663L64.9242 26.0731L65.9055 27.3152L64.1982 29.5084L65.9857 31.7691C66.9488 32.9864 67.8681 33.7742 68.7363 32.6563C69.6045 31.5384 68.7946 30.346 67.9374 29.26L67.2005 28.3302L70.0714 24.6393L70.5457 25.2391C72.9606 28.2983 73.9273 31.6555 70.9579 35.4742C67.9045 39.3957 65.0993 38.2707 62.2247 34.6366V34.6331Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3809 35.0645L60.3668 33.7798L59.546 34.8338L58.5647 33.5917L59.3855 32.5377L58.3349 31.2068L57.5141 32.2608L56.5328 31.0187L57.3536 29.9647L56.2665 28.5913C53.3262 24.8685 52.4726 21.3622 55.5259 17.4371C58.4625 13.661 61.0125 14.6725 63.4311 17.7316L64.2883 18.8176L61.4174 22.5085L60.3668 21.1776C59.5423 20.1342 58.6522 19.0483 57.733 20.2301C56.7991 21.4331 57.6089 22.6682 58.4662 23.7541L60.3412 26.1248L62.0485 23.9316L63.0298 25.1737L61.3225 27.3669L62.3732 28.6977L64.0804 26.5045L65.0617 27.7466L63.3545 29.9399L65.142 32.2005C66.105 33.4178 67.0243 34.2056 67.8925 33.0877C68.7936 31.9272 67.9509 30.7774 67.0936 29.6914L66.3567 28.7616L69.2277 25.0708L69.7019 25.6705C72.1169 28.7297 73.0836 32.0869 70.1141 35.9056C67.1447 39.7242 64.2555 38.7021 61.3809 35.068V35.0645Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.325 44.4942C41.7974 35.7622 41.358 25.7917 35.3437 22.2245C29.3294 18.6572 20.0176 22.844 14.5453 31.576C9.07294 40.308 9.51227 50.2786 15.5266 53.8458C21.5409 57.4131 30.8526 53.2262 36.325 44.4942Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M13.8409 52.5477C18.847 57.5284 28.1033 55.0754 34.5072 47.0659C40.911 39.0597 42.0446 28.5257 37.0319 23.5417C32.5977 19.127 24.8328 20.5487 18.6697 26.4891C17.8705 27.2569 17.098 28.1027 16.3623 29.0234C15.941 29.5504 15.543 30.0872 15.1718 30.6338C9.83807 38.3895 9.15588 47.8923 13.8376 52.5477H13.8409Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1719 30.6349L19.1379 32.037L22.9401 28.1396L18.6698 26.4902C17.8705 27.258 17.098 28.1038 16.3624 29.0245C15.941 29.5515 15.5431 30.0883 15.1719 30.6349Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6289 21.4082L36.0258 24.0303",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0977 22.3516L33.1234 24.759",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9766 24.002L30.3735 26.6241",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8242 42.5723L19.2211 45.1944",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 45.7695L19.2407 48.3917",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6133 48.9727L20.0102 51.5948",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7227 26.5664L26.9156 29.1918",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 30.7266L23.5766 33.3454",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.325 44.4942C41.7974 35.7622 41.358 25.7917 35.3437 22.2245C29.3294 18.6572 20.0176 22.844 14.5453 31.576C9.07294 40.308 9.51227 50.2786 15.5266 53.8458C21.5409 57.4131 30.8526 53.2262 36.325 44.4942Z",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1883 45.545C43.6606 36.813 43.2213 26.8425 37.207 23.2752C31.1927 19.708 21.8809 23.8948 16.4086 32.6268C10.9362 41.3588 11.3756 51.3293 17.3899 54.8966C23.4042 58.4638 32.7159 54.277 38.1883 45.545Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5412 44.5668C41.1857 37.1556 40.8142 28.6941 35.7114 25.6675C30.6085 22.6408 22.7067 26.1952 18.0621 33.6063C13.4175 41.0175 13.789 49.479 18.8919 52.5056C23.9947 55.5323 31.8966 51.9779 36.5412 44.5668Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M36.5412 44.5668C41.1857 37.1556 40.8142 28.6941 35.7114 25.6675C30.6085 22.6408 22.7067 26.1952 18.0621 33.6063C13.4175 41.0175 13.789 49.479 18.8919 52.5056C23.9947 55.5323 31.8966 51.9779 36.5412 44.5668Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5412 44.5668C41.1857 37.1556 40.8142 28.6941 35.7114 25.6675C30.6085 22.6408 22.7067 26.1952 18.0621 33.6063C13.4175 41.0175 13.789 49.479 18.8919 52.5056C23.9947 55.5323 31.8966 51.9779 36.5412 44.5668Z",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2402 46.1889C39.6743 39.3929 40.6341 30.453 36.3838 26.227C36.2467 26.0903 36.1062 25.9635 35.9624 25.8398C36.3771 26.1099 36.7683 26.4222 37.1328 26.7865C41.3831 31.0158 40.4234 39.9524 34.9893 46.7485C29.7291 53.3266 22.205 55.49 17.8711 51.7878C22.2819 54.6734 29.271 52.4059 34.2369 46.1889H34.2402Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4535 47.6071C17.7314 44.1067 18.6176 41.0291 20.8314 38.2248L21.2661 37.675L23.8979 41.0584L23.2224 41.9107C22.4365 42.9062 21.664 43.9603 22.49 45.0241C23.2859 46.0488 24.1286 45.3299 25.0114 44.2108L26.65 42.1384L25.085 40.1279L25.9846 38.9893L27.5496 40.9998L28.5127 39.7798L26.9476 37.7693L27.8472 36.6307L29.4122 38.6412L31.1311 36.468C31.9169 35.4725 32.6593 34.3404 31.8032 33.2375C30.9471 32.1347 30.1446 33.153 29.3888 34.1062L28.4257 35.3261L25.7939 31.9427L26.5798 30.9473C28.7936 28.143 31.1344 27.2158 33.8264 30.6772C36.6253 34.2721 35.8428 37.4863 33.1475 40.9022L32.151 42.1612L32.9034 43.1274L32.0038 44.2661L31.2514 43.2998L30.2884 44.5198L31.0408 45.486L30.1412 46.6247L29.3888 45.6584L28.4592 46.8361C25.8274 50.1674 23.2525 51.202 20.4535 47.6039V47.6071Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2465 48.0017C18.5244 44.5012 19.4106 41.4236 21.6243 38.6193L22.0591 38.0695L24.6908 41.4529L24.0153 42.3052C23.2295 43.3007 22.457 44.3548 23.283 45.4186C24.0789 46.4434 24.9216 45.7244 25.8044 44.6053L27.443 42.533L25.878 40.5225L26.7775 39.3838L28.3425 41.3943L29.3056 40.1744L27.7406 38.1638L28.6402 37.0252L30.2052 39.0357L31.924 36.8626C32.7099 35.8671 33.4523 34.7349 32.5962 33.6321C31.7535 32.5487 30.9375 33.5475 30.1818 34.5007L29.2187 35.7207L26.5869 32.3373L27.3728 31.3418C29.5865 28.5375 31.9274 27.6103 34.6193 31.0718C37.4183 34.6666 36.6358 37.8808 33.9405 41.2967L32.944 42.5557L33.6964 43.522L32.7968 44.6606L32.0444 43.6944L31.0813 44.9143L31.8337 45.8806L30.9342 47.0192L30.1818 46.053L29.2521 47.2307C26.6204 50.562 24.0454 51.5965 21.2465 47.9984V48.0017Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.446416,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6737 87.7967C49.1952 79.3941 46.6696 68.228 38.0325 62.8564C29.3954 57.4848 17.9176 59.9418 12.396 68.3444C6.87452 76.747 9.40018 87.9131 18.0373 93.2847C26.6744 98.6563 38.1522 96.1992 43.6737 87.7967Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M43.6737 87.7967C49.1952 79.3941 46.6696 68.228 38.0325 62.8564C29.3954 57.4848 17.9176 59.9418 12.396 68.3444C6.87452 76.747 9.40018 87.9131 18.0373 93.2847C26.6744 98.6563 38.1522 96.1992 43.6737 87.7967Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 60.4648V63.1878",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 61.3223V65.1928",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6836 62.5859V67.5029",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8984 65.2188V69.0815",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5391 63.293V67.1557",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9844 65.2461V67.4984",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30.097 60.1211C28.7055 59.9694 27.294 59.9655 25.8945 60.1211V95.9908C27.286 96.1503 28.6975 96.1503 30.097 96.0025V60.1211Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6737 87.7967C49.1952 79.3941 46.6696 68.228 38.0325 62.8564C29.3954 57.4848 17.9176 59.9418 12.396 68.3444C6.87452 76.747 9.40018 87.9131 18.0373 93.2847C26.6744 98.6563 38.1522 96.1992 43.6737 87.7967Z",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4508 82.0418C47.7108 72.1446 40.4849 63.1276 30.3115 61.9019C20.138 60.6762 10.8694 67.7058 9.60948 77.603C8.34952 87.5002 15.5753 96.5171 25.7488 97.7428C35.9222 98.9686 45.1908 91.939 46.4508 82.0418Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6541 81.8268C44.7835 73.4359 38.707 65.7431 30.082 64.6444C21.4569 63.5457 13.5493 69.4571 12.4199 77.848C11.2905 86.2389 17.367 93.9317 25.9921 95.0304C34.6172 96.1291 42.5247 90.2177 43.6541 81.8268Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M43.6541 81.8268C44.7835 73.4359 38.707 65.7431 30.082 64.6444C21.4569 63.5457 13.5493 69.4571 12.4199 77.848C11.2905 86.2389 17.367 93.9317 25.9921 95.0304C34.6172 96.1291 42.5247 90.2177 43.6541 81.8268Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6541 81.8268C44.7835 73.4359 38.707 65.7431 30.082 64.6444C21.4569 63.5457 13.5493 69.4571 12.4199 77.848C11.2905 86.2389 17.367 93.9317 25.9921 95.0304C34.6172 96.1291 42.5247 90.2177 43.6541 81.8268Z",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6567 91.0272C30.7672 96.1971 20.8787 94.9562 15.5646 88.2537C13.4453 85.5812 12.3777 82.4459 12.2937 79.3145C12.1778 82.7493 13.2374 86.2425 15.5646 89.1756C20.8787 95.8781 30.7712 97.119 37.6567 91.9492C41.7992 88.8411 43.9065 84.1186 43.7785 79.3961C43.6266 83.8074 41.5273 88.1214 37.6567 91.0272Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3813 77.6391L21.5528 76.4838L20.5292 75.4996L21.6608 74.3832L22.6844 75.3673L23.9 74.1731L22.8764 73.1889L24.008 72.0725L25.0316 73.0567L26.2872 71.8197C29.6859 68.4704 32.9568 67.5601 36.7674 71.2206C40.4341 74.7411 39.5784 77.7013 36.7874 80.4516L35.7958 81.428L32.2091 77.9853L33.4246 76.7911C34.3763 75.8536 35.3679 74.8383 34.2203 73.7374C33.0727 72.6366 31.9172 73.5352 30.9255 74.5115L28.7623 76.6433L30.8935 78.6894L29.7619 79.8058L27.6307 77.7597L26.4151 78.9539L28.5464 81.0001L27.4148 82.1165L25.2835 80.0704L23.2202 82.1048C22.1086 83.2018 21.4009 84.256 22.4885 85.2985C23.6161 86.3799 24.6677 85.423 25.6594 84.4466L26.5071 83.6103L30.0938 87.0529L29.546 87.5897C26.755 90.34 23.6281 91.3903 19.9174 87.827C16.1068 84.1665 17.0624 80.9145 20.3773 77.643L20.3813 77.6391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7836 78.479L21.9552 77.3236L20.9316 76.3395L22.0631 75.223L23.0868 76.2072L24.3024 75.013L23.2787 74.0288L24.4103 72.9124L25.4339 73.8965L26.6895 72.6595C30.0883 69.3102 33.3591 68.4 37.1698 72.0605C40.8365 75.5809 39.9808 78.5412 37.1898 81.2914L36.1981 82.2678L32.6114 78.8252L33.827 77.6309C34.7786 76.6934 35.7703 75.6781 34.6227 74.5773C33.4751 73.4764 32.3195 74.375 31.3279 75.3514L29.1646 77.4831L31.2959 79.5293L30.1643 80.6457L28.033 78.5995L26.8175 79.7938L28.9487 81.8399L27.8171 82.9563L25.6859 80.9102L23.6226 82.9447C22.511 84.0417 21.8032 85.0958 22.8909 86.1384C23.9785 87.1809 25.0701 86.2628 26.0617 85.2864L26.9094 84.4501L30.4961 87.8928L29.9483 88.4296C27.1573 91.1798 24.0304 92.2301 20.3198 88.6669C16.5091 85.0064 17.4648 81.7543 20.7796 78.4828L20.7836 78.479Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.533791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M105.686 68.5886C110.723 60.9238 108.419 50.7381 100.54 45.8382C92.6617 40.9382 82.1916 43.1796 77.1549 50.8444C72.1182 58.5091 74.4221 68.6948 82.3008 73.5948C90.1795 78.4947 100.65 76.2534 105.686 68.5886Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M105.686 68.5886C110.723 60.9238 108.419 50.7381 100.54 45.8382C92.6617 40.9382 82.1916 43.1796 77.1549 50.8444C72.1182 58.5091 74.4221 68.6948 82.3008 73.5948C90.1795 78.4947 100.65 76.2534 105.686 68.5886Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5859 43.7012V46.1851",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2852 44.4902V48.0209",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 45.6328V50.118",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4375 48.0312V51.5549",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.016 46.2637V49.7873",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2984 43.3805C92.029 43.2421 90.7415 43.2386 89.4648 43.3805V76.1007C90.7342 76.2462 92.0217 76.2462 93.2984 76.1113V43.3805Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M105.686 68.5886C110.723 60.9238 108.419 50.7381 100.54 45.8382C92.6617 40.9382 82.1916 43.1796 77.1549 50.8444C72.1182 58.5091 74.4221 68.6948 82.3008 73.5948C90.1795 78.4947 100.65 76.2534 105.686 68.5886Z",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M108.219 63.374C109.368 54.3458 102.777 46.1206 93.4966 45.0025C84.2164 43.8844 75.7616 50.2967 74.6123 59.3249C73.463 68.3531 80.0543 76.5783 89.3345 77.6964C98.6147 78.8145 107.069 72.4022 108.219 63.374Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M105.67 63.165C106.7 55.5109 101.157 48.4935 93.2891 47.4913C85.4213 46.489 78.2081 51.8814 77.1779 59.5355C76.1477 67.1896 81.6906 74.207 89.5583 75.2093C97.4261 76.2115 104.639 70.8191 105.67 63.165Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M105.67 63.165C106.7 55.5109 101.157 48.4935 93.2891 47.4913C85.4213 46.489 78.2081 51.8814 77.1779 59.5355C76.1477 67.1896 81.6906 74.207 89.5583 75.2093C97.4261 76.2115 104.639 70.8191 105.67 63.165Z",
    fill: "black",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M105.67 63.165C106.7 55.5109 101.157 48.4935 93.2891 47.4913C85.4213 46.489 78.2081 51.8814 77.1779 59.5355C76.1477 67.1896 81.6906 74.207 89.5583 75.2093C97.4261 76.2115 104.639 70.8191 105.67 63.165Z",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M100.195 71.5769C93.91 76.2928 84.8897 75.1609 80.0422 69.0469C78.1091 66.6091 77.1352 63.7491 77.0586 60.8926C76.9528 64.0258 77.9194 67.2123 80.0422 69.8879C84.8897 76.0018 93.9136 77.1338 100.195 72.4179C103.973 69.5827 105.896 65.2749 105.779 60.9671C105.64 64.991 103.725 68.9262 100.195 71.5769Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6081 53.7005L93.8154 54.6053L94.6142 53.594L95.7814 54.467L94.9826 55.4783L96.2337 56.4115L97.0325 55.4002L98.1997 56.2731L97.4009 57.2844L98.6921 58.2496C102.19 60.8648 103.408 63.6432 100.428 67.4117C97.565 71.0382 94.7164 70.6159 91.8421 68.4691L90.8209 67.7062L93.6221 64.1613L94.8732 65.0945C95.8507 65.8255 96.9085 66.5849 97.8058 65.4494C98.7031 64.3139 97.7365 63.3984 96.7152 62.6355L94.4866 60.9677L92.8233 63.0755L91.6561 62.2026L93.3194 60.0948L92.0683 59.1615L90.405 61.2693L89.2378 60.3964L90.9011 58.2886L88.7783 56.6989C87.6329 55.8438 86.5715 55.3399 85.7253 56.4151C84.8791 57.4902 85.853 58.349 86.8743 59.1119L87.7497 59.7648L84.9484 63.3097L84.3867 62.891C81.5125 60.7406 80.1848 58.1041 83.0809 54.4386C86.0572 50.6701 89.1941 51.1456 92.6081 53.7005Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8933 54.3763L93.1006 55.2811L93.8994 54.2698L95.0666 55.1427L94.2678 56.154L95.5189 57.0873L96.3177 56.076L97.4849 56.9489L96.6861 57.9602L97.9773 58.9254C101.475 61.5406 102.693 64.319 99.7135 68.0874C96.8502 71.714 94.0015 71.2917 91.1273 69.1449L90.106 68.382L92.9073 64.8371L94.1584 65.7703C95.1359 66.5013 96.1937 67.2607 97.0909 66.1252C97.9882 64.9897 97.0216 64.0742 96.0003 63.3113L93.7717 61.6435L92.1085 63.7513L90.9413 62.8783L92.6045 60.7706L91.3534 59.8373L89.6902 61.9451L88.523 61.0722L90.1863 58.9644L88.0634 57.3747C86.9181 56.5195 85.8567 56.0157 85.0105 57.0908C84.1643 58.166 85.1381 59.0247 86.1594 59.7876L87.0348 60.4406L84.2336 63.9855L83.6718 63.5667C80.7976 61.4164 79.4699 58.7799 82.366 55.1144C85.3424 51.3459 88.4792 51.8214 91.8933 54.3763Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.486922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1433 108.035C84.0569 103.379 90.3045 93.8378 87.0976 86.724C83.8908 79.6102 72.4439 77.618 61.5303 82.2742C50.6167 86.9305 44.3692 96.4719 47.576 103.586C50.7829 110.699 62.2298 112.692 73.1433 108.035Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2293 105.836C83.1429 101.18 89.3904 91.6386 86.1836 84.5248C82.9767 77.411 71.5299 75.4188 60.6163 80.075C49.7027 84.7312 43.4551 94.2727 46.662 101.386C49.8688 108.5 61.3157 110.492 72.2293 105.836Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3454 103.888C80.6063 99.9364 85.9078 91.8398 83.1866 85.8034C80.4654 79.7669 70.7519 78.0764 61.491 82.0275C52.2301 85.9786 46.9286 94.0752 49.6498 100.112C52.371 106.148 62.0845 107.839 71.3454 103.888Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M83.1053 85.6323C69.1851 84.3257 56.5418 93.5758 49.5872 99.98C48.9065 98.4049 48.774 96.6651 49.1273 94.886C49.9368 90.7693 53.3662 86.4306 58.7422 83.3878C65.925 79.3212 74.344 78.8344 79.4293 81.7948C80.4854 82.407 81.3906 83.1695 82.1192 84.0751C82.5129 84.5692 82.8441 85.0918 83.1053 85.6359V85.6323Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M79.4349 81.7913C67.1448 81.3724 55.9991 88.8935 49.1328 94.886C49.9423 90.7693 53.3718 86.4306 58.7478 83.3878C65.9305 79.3212 74.3496 78.8344 79.4349 81.7948V81.7913Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3454 103.888C80.6063 99.9364 85.9078 91.8398 83.1866 85.8034C80.4654 79.7669 70.7519 78.0764 61.491 82.0275C52.2301 85.9786 46.9286 94.0752 49.6498 100.112C52.371 106.148 62.0845 107.839 71.3454 103.888Z",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2787 84.2944C67.9517 79.3866 78.4167 79.6908 82.6557 84.9781C82.7918 85.1464 82.9206 85.3218 83.0383 85.4972C82.7881 85.0032 82.4864 84.5271 82.1221 84.0725C77.8831 78.7852 67.4182 78.4809 58.7452 83.3887C50.3519 88.139 46.7127 96.036 50.3335 101.334C47.6694 96.0754 51.3491 88.7834 59.2787 84.2944Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0367 91.2625L59.4681 90.4105L58.4783 89.5764L59.8618 88.7531L60.8516 89.5871L62.3345 88.7029L61.3447 87.8689L62.7283 87.0455L63.7181 87.8796L65.2488 86.9668C69.3958 84.4967 73.0865 83.949 76.7699 87.0527C80.3134 90.0418 78.9924 92.34 75.585 94.3697L74.3744 95.0892L70.9119 92.1681L72.3948 91.2839C73.5539 90.593 74.7681 89.8413 73.6606 88.9034C72.553 87.9655 71.1731 88.617 69.9625 89.3401L67.3205 90.9152L69.3811 92.6514L67.9976 93.4747L65.9369 91.7386L64.454 92.6228L66.5146 94.3589L65.1311 95.1823L63.0705 93.4461L60.5536 94.946C59.1958 95.755 58.2869 96.5533 59.3356 97.4375C60.3843 98.3217 61.698 97.6523 62.9086 96.9328L63.9462 96.3135L67.4088 99.2346L66.7428 99.6319C63.3354 101.662 59.7845 102.327 56.2005 99.3026C52.6165 96.2777 53.9891 93.6681 58.0367 91.2553V91.2625Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8844 90.3211L59.3158 89.4691L58.326 88.635L59.7095 87.8116L60.6993 88.6457L62.1822 87.7615L61.1924 86.9274L62.576 86.1041L63.5658 86.9382L65.0965 86.0254C69.2435 83.5553 72.9342 83.0076 76.6176 86.1113C80.1611 89.1004 78.8401 91.3986 75.4327 93.4283L74.2221 94.1478L70.7596 91.2267L72.2425 90.3425C73.4016 89.6516 74.6158 88.8999 73.5083 87.962C72.3786 87.0098 71.0208 87.6756 69.8102 88.3987L67.1682 89.9738L69.2288 91.71L67.8453 92.5333L65.7846 90.7972L64.3017 91.6814L66.3623 93.4175L64.9788 94.2409L62.9182 92.5047L60.4013 94.0046C59.0435 94.8136 58.1346 95.6119 59.1833 96.4961C60.232 97.3803 61.5457 96.7109 62.7563 95.9914L63.7939 95.3721L67.2565 98.2932L66.5905 98.6905C63.1831 100.72 59.6322 101.386 56.0482 98.3612C52.3649 95.2539 53.8368 92.7266 57.8844 90.3139V90.3211Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeWidth: 0.491218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_23293",
    x1: 52.83,
    y1: 25.0449,
    x2: 52.83,
    y2: 124.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FBED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo5Euro);
export default __webpack_public_path__ + "static/media/promo5euro.42b530b78cd79ab9be75a4452be694fe.svg";
export { ForwardRef as ReactComponent };